import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import moment from 'moment';
import {
  Grid,
  Box,
  Button,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import DownloadIcon from '../../../assets/icons/download-icon';
import TimeRange from '../../../components/time-range';
import { QueryParameterKeys } from '../../../globals/paramter';
import { AppState } from '../../../store';
import { exportMultiAssetSearchReportsActions } from '../../../store/transactions/actions';
import { enqueueSnackbarAction } from '../../../store/snackbar/actions';
import useStyles from './styles';

const MultiAssetSearchReports = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const classes = useStyles();
  const fileId = useSelector((state: AppState) => state.vimsSFTPReport.fileId);
  const isLoading = useSelector((state: AppState) => state.vimsSFTPReport.isLoading);
  const [assetSerialNumber, setAssetSerialNumber] = useState<string>('');
  const [vimsData, setVimsData] = useState<boolean>(false);

  const parameters: URLSearchParams = new URLSearchParams(location.search);
  const startTime = parameters.get(QueryParameterKeys.startTime) || undefined;
  const endTime = parameters.get(QueryParameterKeys.endTime) || undefined;

  const handleMultiAssetSearchReport = () => {
    let assetSerialNumbers = assetSerialNumber.split(',');
    // Remove duplicates
    assetSerialNumbers = [...new Set(assetSerialNumbers)];

    const differenceDays: number = moment(endTime).diff(startTime, 'days');

    if (differenceDays < 7) {
      if (assetSerialNumbers.length < 10) {
        dispatch(exportMultiAssetSearchReportsActions({ startTime, endTime, vimsData, assetSerialNumbers }));
      } else {
        dispatch(
          enqueueSnackbarAction({
            message: 'No of asset allowed to search - 10 assets',
            options: { variant: 'error' },
          }),
        );
      }
    } else {
      dispatch(
        enqueueSnackbarAction({
          message: 'Date range should be only 7 days',
          options: { variant: 'error' },
        }),
      );
    }
  }
  const toggleVimsFilters = () => {
    setVimsData(!vimsData);
  }

  return (
    <div className={classes.scrollBox}>
      <Grid container>
        <Box ml={1} mr={1}>
          <InputLabel className={classes.label}>Asset Serial Numbers (With comma separator)</InputLabel>
          <TextField className={classes.textBox} variant="standard"
            value={assetSerialNumber}
            onChange={(event) => {
              setAssetSerialNumber(event.target.value as string);
              return event.target.value;
            }} />
        </Box>
        <Box mr={1} mt={1}>
          <FormControlLabel
            control={<Checkbox
              id="chip-vims-data"
              size="small"
              onClick={() => toggleVimsFilters()}
              checked={vimsData}
            />
            }
            label="VIMS Data"
            labelPlacement="start"
          />
        </Box>
        <TimeRange blockFutureDates />

        <Button
          className={classes.button}
          onClick={() => handleMultiAssetSearchReport()}
          variant="outlined"
          size="small"
          endIcon={isLoading ? <CircularProgress size={20} /> : <DownloadIcon />}
          disabled={isLoading}
        >
          <Typography variant="button">
            {isLoading ? 'Processing Report' : 'Download Report'}
          </Typography>
        </Button>

        {fileId}
      </Grid>
    </div>
  );
};

export default MultiAssetSearchReports;
